import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ProveedorUi } from '@xiltrion/ui/proveedor';
import './index.css';
import { SessionProvider } from './app/session';
import { applyTheme } from './app/theme';
import { registerCoreViews } from './core/views';
import { registerExtensions } from './extensions';
import { buildRouter } from './app/routes';

applyTheme();
// Primero el núcleo, luego los paquetes de sector (spec §4.3): el router y las vistas leen del registro.
registerCoreViews();
registerExtensions();

const qc = new QueryClient({ defaultOptions: { queries: { staleTime: 15_000, retry: 1, refetchOnWindowFocus: false } } });
const router = buildRouter();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ProveedorUi>
      <QueryClientProvider client={qc}>
        <SessionProvider>
          <RouterProvider router={router} />
        </SessionProvider>
      </QueryClientProvider>
    </ProveedorUi>
  </React.StrictMode>,
);
